import '../../scss/style.scss';
import jQuery from 'jquery';
import {lazyLoadImages} from '../modules/lazyload_Images';
// import 'jquery-match-height';

require('../original/common.js');
require('../original/customClick.js');

const $ = jQuery;
window.jQuery = jQuery;
// var ua = navigator.userAgent.toLowerCase();
// var isIE = ua.indexOf('msie') >= 0 || ua.indexOf('trident') >= 0;

// var android4xFlg = ua.indexOf('android 4') > 0;
// var isIOS = /iP(hone|(o|a)d)/.test(navigator.userAgent);
var Promise = require('es6-promise');
const FontFaceObserver = require('fontfaceobserver');

const NotoSansJPRegular = new FontFaceObserver('noto_sans_cjk_jp_r');
const NotoSansJPBold = new FontFaceObserver('noto_sans_cjk_jp_b');
const PragatiNarrowB = new FontFaceObserver('PragatiNarrow-B');
const Freedial = new FontFaceObserver('freedial');
Promise.all([NotoSansJPRegular.load(), NotoSansJPBold.load(), PragatiNarrowB.load(), Freedial.load()]).then(function () {
  sessionStorage.fontsLoaded = true;
}).catch(function () {
  sessionStorage.fontsLoaded = false;
});

// win8.1 ie11 mousewheel scroll bug
if (navigator.userAgent.match(/Trident\/7\./)) {
  $('body').on('mousewheel', function () {
    event.preventDefault();
    var wheelDelta = event.wheelDelta;
    var currentScrollPosition = window.pageYOffset;
    window.scrollTo(0, currentScrollPosition - wheelDelta);
  });
}

$('.slide-content img,#flow img').each(function () {
  $(this).attr({
    src: $(this).attr('data-src')
  });
});

$('#campaign img').each(function () {
  $(this).attr({
    src: $(this).attr('data-srcset')
  });
});

// 最初に実行する関数
$(window).on({
  load: function () {
    lazyLoadImages(['.swiper-lazy']);

    // lazyLoadImages();
    // if (isIE) {
    //   // $('#top-vis').find('img').removeClass('swiper-lazy');
    //   $('#top-vis').find('img').each(function () {
    //     $(this).removeClass();
    //     if ($(this).hasClass('is-show')) {
    //       console.log('hasclass');
    //       $(this).removeClass('is-show');
    //     }
    //   });
    //   $('#top-vis').find('img').removeClass('is-show');
    //   $('img').each(function () {
    //     $(this).removeClass('is-lazyimg');
    //     $(this).attr({
    //       src: $(this).attr('data-src')
    //     });
    //   });
    // }
  },
  resize: function () {
    // if (!isIE) lazyLoadImages();
    // lazyLoadImages();
  },
  scroll: function () {
    // if (!isIE) lazyLoadImages();
    // lazyLoadImages();
  }
});
// lazyLoadImages();

// #リンク
$('a[href^="#"]').click(function (e) {
  e.preventDefault();
});

// preload for other browser except chrome
var DOMTokenListSupports = function (tokenList, token) {
  if (!tokenList || !tokenList.supports) {
    return;
  }
  try {
    return tokenList.supports(token);
  } catch (e) {
    if (e instanceof TypeError) {
      console.log("The DOMTokenList doesn't have a supported tokens list");
    } else {
      console.error("That shouldn't have happened");
    }
  }
};

var linkSupportsPreload = DOMTokenListSupports(document.createElement('link').relList, 'preload');
if (!linkSupportsPreload) {
  // Dynamically load the things that relied on preload.
  var links = document.getElementsByTagName('link');
  for (var i = 0; i < links.length; i++) {
    var link = links[i];
    // qualify links to those with rel=preload and as=style attrs
    if (link.rel === 'preload' && link.getAttribute('as') === 'style') {
      // prevent re-running on link
      link.setAttribute('rel', 'stylesheet');
    }
  }
}

// lazyload for background image
document.addEventListener('DOMContentLoaded', function () {
  var lazyBackgrounds = [].slice.call(document.querySelectorAll('.hd-contact'));

  if ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
    let lazyBackgroundObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-lazyimg');
          lazyBackgroundObserver.unobserve(entry.target);
        }
      });
    });

    lazyBackgrounds.forEach(function (lazyBackground) {
      lazyBackgroundObserver.observe(lazyBackground);
    });
  }
});



// WEBPACK FOOTER //
// ./src/js/entries/main.js